import axios from "axios";
import Api from "../api.js";

// Create an Axios instance with default configuration
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "multipart/form-data",
    "ngrok-skip-browser-warning": "1",
  },
});

// Define your service functions
const CulpabilityServices = {
  addNewCulpabilityApi: (formData) => {
    return apiClient.post("/culpability/new", formData);
  },

  updateCulpabilityApi: (id, data) => {
    return apiClient.post(`/culpability/update/${id}`, data);
  },

  getAllCulpabilityApi: (
    page,
    limit,
    status,
    search,
    startDate,
    endDate,
    issueId
  ) => {
    let url = `/culpability/all?page=${page}&limit=${limit}&status=${status}&search=${search}&startDate=${startDate}&endDate=${endDate}&issueId=${issueId}`;

    // if (search) {
    //   url += `&search=${encodeURIComponent(search)}`;
    // }

    return Api.get(url);
  },
  getSingleCulpability: (id) => {
    let url = `/culpability/details/${id}`;
    return Api.get(url);
  },
  deleteFilesApi: (id, data) => {
    console.log("data", id, data);
    return apiClient.post(`/culpability/delete_files/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "1",
      },
    });
  },
  deleteApi: (id) => {
    return apiClient.get(`/culpability/delete/${id}`);
  },
};

export default CulpabilityServices;
